import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  Paper,
} from "@material-ui/core";
import { ApptContext } from "../../../../../../store";
import {
  createAppointment,
  removePreRegistration,
  ReserveSlot,
} from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CircularProgress, Typography } from "@mui/material";  //FB 7468
import useStyles from "../../../../../../css/styles_PE";
import useclasses from "../../../../../../css/styles";  //FB 7468
import Configurations from "../../../../../../config";
import { format } from "date-fns";
import { InsertPPLogs } from "../../../../../../api";
import { LoadingButton } from "@mui/lab"; //FB 7468

// Update log
// FB  6192   02/06/2023  DK  Container component to accomodate slots 
// FB  7443   09/21/2023  DK  Replace Inoffice with In-office across the portal
// FB  7468   10/31/2023  DK  Book appointment is not working on first click
// FB  8024   01/03/2023  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  7681   03/04/2024  KI  Orady - need gear icon on mobile when the doc or any pages are loading

function SlotsContainer(props: any) {
  //FB 7468
  const [loaderArray, setLoaderArray] = useState<Array<string>>([]);
  const classes = useclasses();
  const styles = useStyles();
  const navigate = useNavigate();
  var slot_date = new Date();
  const [expanded, setExpanded] = useState<boolean>(false);
  const [itemsToShow, setItemsToShow] = useState<number>(6);
  const { state, dispatch } = useContext(ApptContext);
  const [selectedSlot, setSelectedSlot] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setSelectedSlot("");
    state.SlotDetails.isslotexisting = true;
    //FB 7468
  };
  const handleDialogClose = async () => {
    if (state.SlotDetails.id != 0) {
      await removePreRegistration(state.SlotDetails.id).then(function () {
        setOpenDialog(false);
        props.onCallback(false);
      });
    }
  };
  // FB 7443
  const apptObj = {
    APPOINTMENT_EXTERNAL_ID: null,
    PATIENT_N: 0,
    EMPLOYEE_N: state.SlotDetails.employeeId,
    APPOINTMENT_DATE: state.SlotDetails.slotDate,
    APPOINTMENT_CHECKIN_TIME: state.SlotDetails.slotDate,
    APPOINTMENT_TYPE_OF_WORK: "",
    APPOINTMENT_IS_ACTIVE: true,
    APPOINTMENT_TYPE_NAME:
      state.AppointmentType === "inoffice"
        ? "In-office Appointment"
        : Configurations.digitalApptType + " Appointment",
    DURATION: props.duration,
    CANCELLATION_REASON: null,
    COMMENT: "",
    COLUMN_NUMBER: 0,
    APPOINTMENT_EXTERNAL_ID_TEXT: null,
    FACILITY_N: state.SlotDetails.facilityId,
    Last_Text_Sent: null,
    Last_Email_Sent: null,
    IsConfirmed: false,
    APPOINTMENT_REVIEWSTARS: 0,
    APPOINTMENT_FEEDBACK: null,
    APPOINTMENT_CREATION_DATE: "",
  };
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  function toggle() {
    setItemsToShow(expanded ? 6 : props.schedulesTest.Slots.length);
    setExpanded(!expanded);
    if (expanded) {
      InsertPPLogs(
        "Click on Show less for " + props.schedulesTest.ScheduleDate,
        window.location.href,
        userName,
        ""
      );
    } else {
      InsertPPLogs(
        "Click on Show More for " + props.schedulesTest.ScheduleDate,
        window.location.href,
        userName,
        ""
      );
    }
  }

  //FB 7468 - Start

  async function ManageSlot(slot: any) {
    setLoaderArray([...loaderArray, props.facilityid + "_" + props.schedulesTest.ScheduleDate + "_" + slot]);
    setSelectedSlot(slot);
    InsertPPLogs(
      "Click on time slot " + slot,
      window.location.href,
      userName,
      ""
    );
    if (slot != "") {
      props.onCallback(true);
      slot_date = new Date(props.schedulesTest.ScheduleDate + " " + slot);
      var x = slot_date.getTimezoneOffset();
      slot_date.setMinutes(slot_date.getMinutes() - x);
      const preRegistrationObj = {
        EMPLOYEE_N: props.employeeid,
        FACILITY_N: props.facilityid,
        PRE_REGISTRATION_DATE: slot_date,
        PRE_REGISTRATION_SLOT_TIME: slot_date,
      };

      await ReserveSlot(preRegistrationObj).then((data) => {
        if (data == 0) {
          setOpen(true);
        } else {
          state.SlotDetails.employeeId = props.employeeid;
          state.SlotDetails.facilityId = props.facilityid;
          state.SlotDetails.id = data;
          state.SlotDetails.slotDate = new Date(
            props.schedulesTest.ScheduleDate + " " + slot
          );
          state.SlotDetails.employeeName = props.employeeName;
          state.SlotDetails.facilityName = props.facilityName;
          state.SlotDetails.isslotexisting = false;
          state.SlotDetails.duration = props.duration;

          if (state.AppointmentFilter === "provider") {
            state.Facility.Name = props.facilityName;
            state.Facility.Address = props.facilityAddress;
          }

          state.Facility.Phone = props.facilityPhone;
          state.Duration = props.duration;
          setOpenDialog(true);
        }
      });
      setLoaderArray(loaderArray.filter((la) => la != props.facilityid + "_" + props.schedulesTest.ScheduleDate + "_" + slot)); //FB 7681
    }
  }
  //FB 7468 - End

  async function BookAppointment() {
    let patient_n = 0;
    let data = sessionStorage.getItem("user");
    if (data != null) {
      patient_n = JSON.parse(data).EMRID;
    }
    if (state.SlotDetails.id != 0) {
      apptObj.EMPLOYEE_N = state.SlotDetails.employeeId;
      apptObj.FACILITY_N = state.SlotDetails.facilityId;
      var date = new Date(
        props.schedulesTest.ScheduleDate + " " + selectedSlot
      );
      var x = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - x);
      apptObj.APPOINTMENT_DATE = date;
      apptObj.APPOINTMENT_CHECKIN_TIME = date;
      apptObj.PATIENT_N = patient_n;
      apptObj.APPOINTMENT_CREATION_DATE = format(new Date(), "yyyy-MM-dd");
      //FB 8024 - Begin
      if (Number(sessionAppointmentDuration) > 0) {
        apptObj.DURATION = Number(sessionAppointmentDuration);
        apptObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
        apptObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
      }
      //FB 8024 - End
      let result = await createAppointment(apptObj);
      if (result != 0) {
        state.Appointment_N = result;
        InsertPPLogs("Appointment Booked", window.location.href, userName, "");
        navigate("/user/bookappointment/confirmation");
      }
      await removePreRegistration(state.SlotDetails.id);
    }
    setOpenDialog(false);
  }

  //FB 7468

  //FB 8024 - Begin
  const [sessionAppointment_n, setSessionAppointment_n] = React.useState("");
  const [sessionAppointment, setSessionAppointment] = React.useState("");
  const [sessionAppointmentDuration, setSessionAppointmentDuration] = React.useState("");
  const getSessionStorageValues = () => {
    const appt_n = sessionStorage.getItem("AppointmentType_N");
    const appt = sessionStorage.getItem("AppointmentType");
    const appt_duration = sessionStorage.getItem("Duration");
    setSessionAppointment_n(appt_n!);
    setSessionAppointment(appt!);
    setSessionAppointmentDuration(appt_duration!);
  }

  useEffect(() => {
    getSessionStorageValues();
  }, []);
  //FB 8024 - End

  return (
    <React.Fragment>
      <Dialog
        open={open}
        id="differentSlotDialog"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Slot is already booked!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select a different slot.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {props.limited === 1 ? (
        <Grid
          container
          direction="row"
          alignContent="center"
          style={{ display: "flex", flexFlow: "nowrap" }}
        >
          {props.schedulesTest.Slots.map((slot: string, index: number) => {
            return (
              <Grid container className={styles.topBarItem} key={index}>
			  {/* FB 7681  - Start*/}
                <LoadingButton
                    className={classes.textbutton}
                    loading={
                      loaderArray.indexOf(props.facilityid +
                        "_" +
                        props.schedulesTest.ScheduleDate +
                        "_" +
                        slot) > -1
                    }
                    loadingPosition="center"
                    loadingIndicator={
                      <CircularProgress
                        size={20}
                        style={{ color: "#083A4D" }}
                      />
                    }
                    onClick={() => ManageSlot(slot)}
                  >
                    {loaderArray.indexOf(props.facilityid +
                        "_" +
                        props.schedulesTest.ScheduleDate +
                        "_" +
                        slot) > -1 ? (<div
                          className={`${styles.flexRow} ${styles.timeSlotItem}`}
                          style={{ width: "100px", height: "40px" }}
                        >
                          ""
                        </div>) : (<div
                  className={`${styles.flexRow} ${styles.timeSlotItem}`}
                  style={{ width: "100px", height: "40px" }}
              
                >
                  {slot}
                </div>
                    )}
                  </LoadingButton>
                {/* FB 7681  - end*/}
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Grid item sm={2} md={2}>
          {props.schedulesTest.Slots.slice(0, itemsToShow).map(
            (slot: string) => {
              return (
                <Paper className={styles.slots_paper}>
                  {/* FB 7468  - Start*/}
                  <LoadingButton
                    className={classes.textbutton}
                    loading={
                      loaderArray.indexOf(props.facilityid +
                        "_" +
                        props.schedulesTest.ScheduleDate +
                        "_" +
                        slot) > -1
                    }
                    loadingPosition="center"
                    loadingIndicator={
                      <CircularProgress
                        size={20}
                        style={{ color: "#083A4D" }}
                      />
                    }
                    onClick={() => ManageSlot(slot)}
                  >
				  {/* FB 7681  - start*/}
                    {loaderArray.indexOf(props.facilityid +
                        "_" +
                        props.schedulesTest.ScheduleDate +
                        "_" +
                        slot) > -1 ? "" : (<p
                          id={
                            props.facilityid +
                            "_" +
                            props.schedulesTest.ScheduleDate +
                            "_" +
                            slot
                          }
                          className={styles.slot}
    
                        >
                          {slot}
                        </p>)}    
						{/* FB 7681  - End*/}
                  </LoadingButton>
                  {/* FB 7468  - End*/}
                </Paper>
              );
            }
          )}
          {props.schedulesTest.Slots.length < 6 ||
            props.schedulesTest.Slots.length === 0 ? (
            <div></div>
          ) : (
            <Paper className={styles.slots_paper}>
              <p
                className={styles.slot}
                style={{ maxWidth: 60, textAlign: "center" }}
                onClick={toggle}
              >
                {expanded ? "Show Less" : "Show More"}
              </p>
            </Paper>
          )}
        </Grid>
      )}
      <Dialog onClose={handleDialogClose} maxWidth={"xs"} open={openDialog}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 10,
              }}
            >
              <Card
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "400px",
                }}
              >
                <CardHeader
                  style={{
                    backgroundColor: "#2FABBF",
                    color: "white",
                  }}
                  title="Appointment Time:"
                  subheader={
                    <Typography style={{ color: "white" }}>
                      {new Date(
                        props.schedulesTest.ScheduleDate + " " + selectedSlot
                      ).toLocaleDateString() +
                        " at " +
                        new Date(
                          props.schedulesTest.ScheduleDate + " " + selectedSlot
                        ).toLocaleString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                    </Typography>
                  }
                />
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    {props.employeeName}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      display:
                        state.AppointmentType === "telederm" ? "none" : "flex",
                    }}
                  >
                    {props.facilityName === null ||
                      props.facilityName === undefined
                      ? ""
                      : props.facilityName}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={() => BookAppointment()}
          >
            Book Appointment
          </Button>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleDialogClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default SlotsContainer;
